import InstagramSelectorReducer from '@/common/reducers/InstagramSelectorSlice';
import { Task } from "@common-models/task";
import AutomationReducer from "@common-reducers/AutomationReducer";
import MediaManagerReducer from "@common-reducers/MediaManagerReducer";
import knowledgeBaseProgressReducer from "@common/reducers/KnowledgeBaseProgressSlice";
import OAuthTestReducer from '@common/reducers/OAuthTestSlice';

import AccessFormPopupReducer from "@common-reducers/AccessFormPopupReducer";
import AddScheduledMessageButtonReducer from "@common-reducers/AddScheduledMessageButtonReducer";
import SubscriptionHydrationReducer from "@common-reducers/subscription-hydration";
import backendApi, {
  initAppData,
  middleware
} from "@common-reducers/backend-api/backend-api";
import { k8sApi } from "@common-reducers/backend-api/backend-k8s-api";
import BoardsReducer from "@common-reducers/BoardsReducer";
import BoardViewReducer from "@common-reducers/BoardviewReducers";
import BulkActionsReducer from "@common-reducers/BulkActionsReducer";
import CampaignReducer from "@common-reducers/CampaignReducer";
import ChatListReducer from "@common-reducers/ChatListReducer";
import { ContactTableReducer } from "@common-reducers/ContactTableReducer";
import CreditPurchaseReducer from "@common-reducers/CreditPurchaseReducer";
import CreditUsageReducer from "@common-reducers/CreditUsageReducer";
import {
  DBAllocatedPhoneNumberReducer,
  DBAuthTokensReducer,
  DBAutomationActionsReducer,
  DBAutomationConditionsReducer,
  DBAutomationReducer,
  DBAutomationSessionReducer,
  DBAutomationTriggerReducer,
  DBBoardsReducer,
  DBBoardUserReducer,
  DBBoardViewReducer,
  DBBotDeploymentReducer,
  DBBotReducer,
  DBBulkListReducer,
  DBCampaignReducer,
  DBDripReducer,
  DBDripTemplateReducer,
  DBCampaignLogReducer,
  DBContactReducer,
  DBContactsLabelsReducer,
  DBEntitySubscribersReducer,
  DBFeatureReducer, DBFormReducer, DBGanttReducer,
  DBInvoiceReducer, DBKanbanReducer,
  DBKnowledgeBaseDocumentReducer,
  DBKnowledgeBaseEntryReducer,
  DBKnowledgeBaseReducer,
  DBLabelReducer,
  DBLogReducer,
  DBMessageLogReducer,
  DBMyWorksReducer,
  DBNewTabFocusReducer,
  DBNodeEventsReducer,
  DBNotificationsReducer,
  DBQuickLaunchReducer,
  DBSessionEventsReducer,
  DBSessionReducer,
  DBSubscriptionReducer, DBEmailSendReducer, DBTaskColumnOptionReducer, DBTaskColumnReducer, DBTaskgroupsReducer,
  DBTasksExtraDataFilesReducer,
  DBTasksExtraDataReducer,
  DBTasksReducer,
  DBTeamInboxChatsCacheReducer,
  DBTeamInboxMessagesCacheReducer,
  DBTemplateReducer,
  DBTimeTrackingSessionReducer,
  DBTracingsReducer,
  DBUserMessageReducer,
  DBUserReducer,
  DBViewFiltersReducer,
  DBWaChatReducer,
  DBWaContactsCacheReducer,
  DBWaNoteReducer,
  DBWebhooksReducer,
  DBWorkloadReducer,
  DBWorkspaceReducer,
  DBWorkspaceUserReducer,
  DBRemindersReducer,
} from "@common-reducers/DBServiceThunks";
import ExtraDataReducer from "@common-reducers/ExtraDataReducer";
import GanttReducer from "@common-reducers/GanttReducers";
import ImportItemsReducer from "@common-reducers/ImportItemsReducer";
import KanbanReducer from "@common-reducers/KanbanReducers";
import LabelsReducer from "@common-reducers/LabelsReducer";
import MainReducer, {
  initStorageWrapper,
} from "@common-reducers/MainReducer";
import ModalReducer from "@common-reducers/ModalReducer";
import PickerDialogReducer from "@common-reducers/PickerDialogReducer";
import ProfilePicReducer from "@common-reducers/ProfilePicReducer";
import ShareDialogReducer from "@common-reducers/ShareDialogReducer";
import SnippetsReducer from "@common-reducers/SnippetsReducer";
import SubscriptionPopupReducer from "@common-reducers/SubscriptionPopupReducer";
import TasksReducer from "@common-reducers/TasksReducer";
import UndoRedoReducer from "@common-reducers/UndoRedoReducer";
import UninstallReducer from "@common-reducers/UninstallReducer";
import UserReducer from "@common-reducers/UserReducer";

import {
  initAuth
} from "@/common/bt-auth/AuthThunks";
import WhatsAppReducer from "@common-reducers/WhatsAppReducer";
import WorkspaceReducer from "@common-reducers/WorkspaceReducer";
import { isBackground } from "@common-services/detect-context";
import {
  configureStore
} from "@reduxjs/toolkit";

import NotifierReducer from "@/common/noifier-module/NotifierReducer";
import BtQuickPanelReducer from "@common-reducers/BtQuickPanelReducer";
import CalendarReducer from "@common-reducers/CalendarReducer";
import PlannerSentHistoryReducer from "@common-reducers/planner-sent-history";
import LabelReducer from "@common-reducers/labels-reducer";
import MyWorkReducer from "@common-reducers/MyWorkReducer";
import PaymentFormReducer from "@common-reducers/PaymentFormReducer";
import RecycleBinReducer from "@common-reducers/RecycleBinReducer";
import StickyHeaderReducer from "@common-reducers/StickyHeaderReducer";
import ToolsReducer from '@common-reducers/ToolsReducer';
import WhatsAppViewReducer from "@common-reducers/WhatsAppViewReducer";
import ChatbotReducer from "@common/reducers/ChatbotReducer";
import connectedEnginesReducer from '@common/reducers/ConnectedEnginesSlice';
import ConnectionReadinessSlice from "@common/reducers/ConnectionReadinessSlice";
import ScheduledMessageEditorReducer from "@common/reducers/ScheduledMessageEditorReducer";
import ToolSettingsModalReducer from '@common/reducers/ToolSettingsModalReducer';
import UserMessageReducer from "@common/reducers/UserMessageReducer";
import MessageInfoReducer from "@common/reducers/MessageInfoReducer";
import NudgeReducer from "@common/reducers/nudge-slice";
import DripEditorReducer from "@common/reducers/DripEditorReducer";
import { FreeLimitReducer } from "@common/reducers/free-limit-slice";
import BtLayoutSidebarReducer from "@common/reducers/BtLayoutSidebarReducer";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import dashboardStatsReducer from '../../pages/bot-usage-dashboard/dashboardStatsSlice';
import TeamInboxReducer from "@/components/team-inbox/redux/TeamInboxReducer";
import RemindersUIReducer from "@common/reducers/RemindersUIReducer";

// Define the SessionEvents slic


let reducerMap = {
  DBKnowledgeBaseReducer,
  DBKnowledgeBaseDocumentReducer,
  DBKnowledgeBaseEntryReducer,
  DBSessionReducer,
  DBBulkListReducer,
  DBContactReducer,
  DBTemplateReducer,
  DBLabelReducer,
  DBCampaignReducer,
  DBDripReducer,
  DBDripTemplateReducer,
  DBCampaignLogReducer,
  DBTaskgroupsReducer,
  DBTasksExtraDataReducer,
  DBTasksExtraDataFilesReducer,
  DBMessageLogReducer,
  DBWaChatReducer,
  DBLogReducer,
  DBViewFiltersReducer,
  DBBoardsReducer,
  DBTasksReducer,
  DBTeamInboxChatsCacheReducer,
  DBTeamInboxMessagesCacheReducer,
  DBInvoiceReducer,
  DBTaskColumnReducer,
  DBTaskColumnOptionReducer,
  DBUserReducer,
  DBWorkspaceReducer,
  DBKanbanReducer,
  DBBoardViewReducer,
  DBFeatureReducer,
  DBMyWorksReducer,
  DBGanttReducer,
  DBFormReducer,
  DBWorkloadReducer,
  DBWorkspaceUserReducer,
  DBBoardUserReducer,
  DBSubscriptionReducer,
  DBEmailSendReducer,
  DBTimeTrackingSessionReducer,
  DBAutomationReducer,
  DBAutomationTriggerReducer,
  DBAutomationConditionsReducer,
  DBAutomationActionsReducer,
  DBNewTabFocusReducer,
  DBWebhooksReducer,
  DBAllocatedPhoneNumberReducer,
  DBAuthTokensReducer,
  UndoRedoReducer,
  ChatListReducer,
  TasksReducer,
  TeamInboxReducer,
  MyWorkReducer,
  KanbanReducer,
  BoardViewReducer,
  GanttReducer,
  BulkActionsReducer,
  BoardsReducer,
  WhatsAppReducer,
  PickerDialogReducer,
  MainReducer,
  DBTracingsReducer,
  MediaManagerReducer,
  AutomationReducer,
  ExtraDataReducer,
  ShareDialogReducer,
  LabelsReducer,
  SubscriptionPopupReducer,
  CampaignReducer,
  UserReducer,
  ChatbotReducer,
  CalendarReducer,
  PlannerSentHistoryReducer,
  ContactTableReducer,
  DBUserMessageReducer,
  ProfilePicReducer,
  SnippetsReducer,
  AddScheduledMessageButtonReducer,
  SubscriptionHydrationReducer,
  AccessFormPopupReducer,
  backendApi,
  UninstallReducer,
  ModalReducer,
  ImportItemsReducer,
  WorkspaceReducer,
  WhatsAppViewReducer,
  NotifierReducer,
  DBQuickLaunchReducer,
  BtQuickPanelReducer,
  PaymentFormReducer,
  RecycleBinReducer,
  LabelReducer,
  DBEntitySubscribersReducer,
  DBNotificationsReducer,
  DBContactsLabelsReducer,
  StickyHeaderReducer,
  DBBotReducer,
  DBSessionEventsReducer,
  DBWaContactsCacheReducer,
  DBWaNoteReducer,
  UserMessageReducer,
  DBBotDeploymentReducer,
  ConnectionReadinessSlice,
  DBAutomationSessionReducer,
  DBNodeEventsReducer,
  ConnectedEnginesReducer: connectedEnginesReducer,
  ToolsReducer,
  ToolSettingsModalReducer,
  CreditUsageReducer,
  creditPurchase: CreditPurchaseReducer,
  KnowledgeBaseProgressReducer: knowledgeBaseProgressReducer,
  OAuthTestReducer,
  InstagramSelectorReducer,
  dashboardStats: dashboardStatsReducer,
  ScheduledMessageEditorReducer,
  MessageInfoReducer,
  BtLayoutSidebarReducer,
  DBRemindersReducer,
  RemindersUIReducer,
  NudgeReducer,
  DripEditorReducer,
  FreeLimitReducer,
  [k8sApi.reducerPath]: k8sApi.reducer,
};

if (isBackground()) {
  reducerMap = {} as any;
}

const ignoreLargePathList = [
  "WhatsAppReducer.contactList",
  "WhatsAppReducer.contactMap",
];

const createStore = () =>
  configureStore({
    /* Uncomment this to debug extension */
    // devTools: false,
    // enhancers,
    reducer: reducerMap,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // immutableCheck is expensive — dev builds only (staging/prod skip it)
        immutableCheck: process.env.NODE_ENV === 'development'
          ? { ignoredPaths: ignoreLargePathList }
          : false,
        serializableCheck: false,
      }).concat(middleware, k8sApi.middleware),
  });

const __globalAny = globalThis as any;
const store = __globalAny.__APP_STORE__ ?? createStore();

if (!__globalAny.__APP_STORE__) {
  __globalAny.__APP_STORE__ = store;
  console.log("init: app functions");
  store.dispatch(initAuth());
  store.dispatch(initAppData());
  store.dispatch(initStorageWrapper());
}

export interface ScheduleTaskData {
  task: Task;
  to: string;
}

export default store;

export type WebRootState = ReturnType<typeof store.getState>;

export const useWebThunkDispatch = () => useDispatch<typeof store.dispatch>();
export const useWebDispatch = () => useDispatch<typeof store.dispatch>();
// Use default reference equality to avoid heavy deep comparisons on every render
export const useWebSelector: TypedUseSelectorHook<WebRootState> = (selector) => useSelector(selector);
